import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-FormSection p-2 text-center mb-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fw-bold" }, "View in Progress", -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "fw-bold mb-2"
}
const _hoisted_5 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "big-text mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save In Progress...")
], -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "col-12 ps-2"
}
const _hoisted_10 = { class: "row p-2 mb-0" }
const _hoisted_11 = { class: "form-group col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "hospitalization-admission-date" }, [
  /*#__PURE__*/_createTextVNode(" Admission Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_13 = { class: "input-group date datepickerInput" }
const _hoisted_14 = ["value", "disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_16 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_17 = { class: "form-group col-md-3" }
const _hoisted_18 = { for: "hospitalization-discharge-date" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Discharge Date ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "input-group date datepickerInput" }
const _hoisted_24 = ["value", "disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_26 = { class: "form-check col-md-2 mt-4 ms-1" }
const _hoisted_27 = ["id", "disabled"]
const _hoisted_28 = ["for"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Emergency Department Encounter", -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "form-group col-12 col-md-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "hospital-unit" }, "Hospital Unit", -1 /* HOISTED */)
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "form-group col-12 col-lg-2 d-flex" }
const _hoisted_35 = { class: "form-group form-check custom-checkbox" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-4",
  for: "is-planned"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Planned")
], -1 /* HOISTED */)
const _hoisted_38 = { class: "form-group form-check custom-checkbox" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label me-4",
  for: "is-preventable"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Preventable")
], -1 /* HOISTED */)
const _hoisted_41 = { class: "row p-2 form-group mb-0" }
const _hoisted_42 = { class: "form-group col-12 col-lg-3 pe-lg-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "facility-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Facility Name")
], -1 /* HOISTED */)
const _hoisted_44 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "facility-contact-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Facility Point of Contact Name")
], -1 /* HOISTED */)
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_49 = { class: "col-12 ps-2" }
const _hoisted_50 = { class: "form-group p-2 col-md-12" }
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "row col-12" }
const _hoisted_53 = { class: "col-md-11" }
const _hoisted_54 = { class: "form-check mx-auto ps-0 col-md-1" }
const _hoisted_55 = ["id", "disabled"]
const _hoisted_56 = ["for"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "Unknown", -1 /* HOISTED */)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "col-12 px-3" }
const _hoisted_60 = { class: "form-group col-md-12" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "discharged-to" }, " Discharged To ", -1 /* HOISTED */)
const _hoisted_62 = ["id", "disabled"]
const _hoisted_63 = { class: "form-group col-md-12" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { for: "comments" }, " Comments ", -1 /* HOISTED */)
const _hoisted_65 = ["id", "maxlength", "disabled"]
const _hoisted_66 = {
  key: 2,
  class: "col-md-12 d-flex justify-content-center align-items-center pb-2 mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DiagnosisTable = _resolveComponent("DiagnosisTable")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isViewDetailsRequested)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("v-if", true),
    (_ctx.isViewDetailsRequested)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_4, "Hospitalizations/Emergency Department Encounters"))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_FormSection, {
      "full-height": false,
      application: _ctx.application
    }, {
      content: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, _hoisted_8))
          : (_openBlock(), _createElementBlock("section", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("input", {
                          type: "text",
                          name: "hospitalization-admission-date",
                          class: "form-control",
                          value: _ctx.formatDateInput(_ctx.hospitalization.AdmissionDate),
                          placeholder: "MM/DD/YYYY",
                          autocomplete: "off",
                          disabled: _ctx.isViewDetailsRequested,
                          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.hospitalization.AdmissionDate.$touch && _ctx.v$.hospitalization.AdmissionDate.$touch(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_14),
                        _hoisted_15,
                        (_ctx.v$.hospitalization.AdmissionDate.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Admission Date is required."))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _hoisted_19,
                    (_ctx.patientInfo.isHospitalized && _ctx.hospitalization.IsStatusUpdateData)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22)), [
                          [_directive_tooltip, {
                                    title: `To add a discharge date, change the patient's status back to Active.`
                                }]
                        ])
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("input", {
                          type: "text",
                          name: "hospitalization-discharge-date",
                          class: "form-control",
                          value: _ctx.formatDateInput(_ctx.hospitalization.DischargeDate),
                          placeholder: "MM/DD/YYYY",
                          autocomplete: "off",
                          disabled: 
                                        (_ctx.patientInfo.isHospitalized && _ctx.hospitalization.IsStatusUpdateData) ||
                                        _ctx.isViewDetailsRequested
                                    ,
                          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_24),
                        _hoisted_25
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    id: `ed-encounter-${_ctx.hospitalization.Id}`,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.hospitalization.IsEdEncounter) = $event)),
                    disabled: _ctx.isViewDetailsRequested
                  }, null, 8 /* PROPS */, _hoisted_27), [
                    [_vModelCheckbox, _ctx.hospitalization.IsEdEncounter]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `ed-encounter-${_ctx.hospitalization.Id}`
                  }, _hoisted_30, 8 /* PROPS */, _hoisted_28)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    placeholder: "Enter Hospital Unit",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hospitalization.HospitalUnit) = $event)),
                    disabled: _ctx.isViewDetailsRequested
                  }, null, 8 /* PROPS */, _hoisted_33), [
                    [_vModelText, _ctx.hospitalization.HospitalUnit]
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "is-planned",
                      value: true,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hospitalization.IsPlanned) = $event)),
                      disabled: _ctx.isViewDetailsRequested
                    }, null, 8 /* PROPS */, _hoisted_36), [
                      [_vModelCheckbox, _ctx.hospitalization.IsPlanned]
                    ]),
                    _hoisted_37
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "is-preventable",
                      value: true,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.hospitalization.IsPreventable) = $event)),
                      disabled: _ctx.isViewDetailsRequested
                    }, null, 8 /* PROPS */, _hoisted_39), [
                      [_vModelCheckbox, _ctx.hospitalization.IsPreventable]
                    ]),
                    _hoisted_40
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getVendorList,
                    value: _ctx.selectedHospitalizedFacility,
                    onValueChanged: _ctx.handleSelectedFacilityChange,
                    placeholder: "Enter Facility Name...",
                    debounce: 100,
                    disabled: _ctx.isViewDetailsRequested
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Name",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.hospitalization.FacilityContactName) = $event)),
                    disabled: _ctx.isViewDetailsRequested
                  }, null, 8 /* PROPS */, _hoisted_46), [
                    [_vModelText, _ctx.hospitalization.FacilityContactName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getUsersByRole,
                    value: _ctx.selectedCommunityLiaison,
                    onValueChanged: _ctx.handleSelectedCommunityLiaison,
                    "init-:value": "selectedCommunityLiaison",
                    placeholder: "Enter Community Liaison...",
                    disabled: _ctx.isViewDetailsRequested
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled"])
                ])
              ])
            ])),
        _createElementVNode("section", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("label", {
              for: `discharge-diagnosis-${_ctx.hospitalization.Id}`
            }, " Discharge Diagnoses ", 8 /* PROPS */, _hoisted_51),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_component_DiagnosisTable, {
                  diagnosis: _ctx.hospitalization.HospitalizationHistoryDiagnoses,
                  updateDiagnosis: _ctx.handleUpdateDiagnosis,
                  limit: _ctx.diagnosisLimit,
                  "history-view": true,
                  "hide-resolved": true,
                  "is-view-details-requested": _ctx.isViewDetailsRequested,
                  application: _ctx.application
                }, null, 8 /* PROPS */, ["diagnosis", "updateDiagnosis", "limit", "is-view-details-requested", "application"])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "mx-1",
                  id: `unknown-diagnosis-${_ctx.hospitalization.Id}`,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isDiagnosisUnknown) = $event)),
                  disabled: _ctx.isViewDetailsRequested
                }, null, 8 /* PROPS */, _hoisted_55), [
                  [_vModelCheckbox, _ctx.isDiagnosisUnknown]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `unknown-diagnosis-${_ctx.hospitalization.Id}`
                }, _hoisted_58, 8 /* PROPS */, _hoisted_56)
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              maxlength: "50",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.hospitalization.DischargedTo) = $event)),
              id: `discharged-to-${_ctx.hospitalization.Id}`,
              placeholder: "Enter Location",
              disabled: !_ctx.hospitalization.DischargeDate || _ctx.isViewDetailsRequested
            }, null, 8 /* PROPS */, _hoisted_62), [
              [_vModelText, _ctx.hospitalization.DischargedTo]
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              id: `comments-${_ctx.hospitalization.Id}`,
              rows: "4",
              maxlength: _ctx.maxLength,
              placeholder: "Enter Comments",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.hospitalization.Comments) = $event)),
              disabled: _ctx.isViewDetailsRequested
            }, null, 8 /* PROPS */, _hoisted_65), [
              [_vModelText, _ctx.hospitalization.Comments]
            ]),
            _createElementVNode("p", {
              class: _normalizeClass(`mb-0 ${_ctx.maxLength == _ctx.hospitalization.Comments.length ? 'text-danger' : ''}`)
            }, " You have " + _toDisplayString(_ctx.maxLength - _ctx.hospitalization.Comments.length) + " remaining characters. ", 3 /* TEXT, CLASS */)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["application"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          (!_ctx.isViewDetailsRequested)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary btn-md me-2",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save()))
              }, " Save "))
            : _createCommentVNode("v-if", true),
          (!_ctx.isViewDetailsRequested)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-outline-primary btn-md",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cancel()))
              }, " Cancel "))
            : _createCommentVNode("v-if", true),
          (_ctx.isViewDetailsRequested)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn btn-primary btn-md mt-2",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.close()))
              }, " Close "))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}